/* global Lang */

import React from 'react';
import styled from 'styled-components';
import Card, { CardBody } from '../Card';
import ProgressBar from '../ProgressBar';
import PowerIcon from '../../../game/components/Power/Icon';

const HeroPowerUsage = ({
  className, hero, allPowers, usedPowers,
}) => (
  <Card className={className}>
    <CardBody className="p-0">
      <table className="table table-striped mb-0 w-100">
        <thead className="thead-dark">
          <tr className="text-nowrap">
            <th colSpan={2}>{Lang.get('messages.dashboard.powersUsed.power')}</th>
            <th>{Lang.get('messages.dashboard.powersUsed.amount')}</th>
            <th>{Lang.get('messages.dashboard.powersUsed.succeeded')}</th>
            <th>{Lang.get('messages.dashboard.powersUsed.failed')}</th>
          </tr>
        </thead>
        <tbody>
          {allPowers.map((power) => {
            if (power.hero.slug !== hero.slug) {
              return null;
            }
            const { used = '-', failed = '-', success = '-' } = (usedPowers[power.domain] && usedPowers[power.domain][power.slug]) || {};
            const unlocked = used !== '-';
            return (
              <tr key={power.slug} className={unlocked ? '' : 'text-muted'}>
                <td className="align-middle" width="50">
                  <PowerIcon
                    className="float-left overflow-hidden align-middle"
                    color={hero.color}
                    id={`${hero.name}_${power.slug}`}
                    unlocked={unlocked}
                  />
                </td>
                <td className="align-middle pl-0">{power.title}</td>
                <td className="align-middle">{used}</td>
                <td className="align-middle" colSpan="2">
                  <div className="d-flex align-items-center">
                    <span>{success}</span>
                    {unlocked && (
                      <ProgressBar
                        className="mx-2"
                        value={success}
                        max={used}
                        trackColor={used > 0 ? 'danger' : 'secondary progress-bar-striped'}
                        fillColor="success"
                      />
                    )}
                    <span>{failed}</span>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </CardBody>
  </Card>
);

export default styled(HeroPowerUsage)`
  max-width: 100%;
  width: 500px;

  @media screen and (min-width: 768px) {
    margin: -40px -20px 20px;
    position: absolute;
    top: 0;
    left: 100%;
    z-index: 2;
  }
`;
